export default function PortfolioSkeleton() {
  const items = new Array(12).fill(0);

  return (
    <section className="py-5 bg-light">
      {/* Heading Skeleton */}
      <div className="text-center mb-4">
        <div className="bg-[#d1d5dc] rounded mx-auto mb-2" style={{ height: 24, width: 200 }}></div>
        <div className="bg-[#d1d5dc] rounded mx-auto" style={{ height: 4, width: 100 }}></div>
      </div>

      {/* Grid */}
      <div className="row g-4 px-3">
        {items.map((_, index) => (
          <div
            key={index}
            className={`col-6 col-sm-4 col-md-3 col-lg-2 text-center 
              ${index >= 4 ? "d-none d-sm-block" : ""}`}
          >
            <div
              className="rounded-circle border border-[#d1d5dc] d-flex align-items-center justify-content-center mx-auto"
              style={{ width: 140, height: 140 }}
            >
              <div>
                <div className="bg-[#d1d5dc] rounded mx-auto mb-2" style={{ height: 16, width: 60 }}></div>
                <div className="bg-[#d1d5dc] rounded mx-auto" style={{ height: 10, width: 80 }}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}